import IAccountNavigationElements from './IAccountNavigationElements';

const find = <E extends Element = Element>(selector: string) => document.querySelector(selector) as E;

export default {
  getAll() {
    return {
      $btn: find<HTMLButtonElement>('#tn-utility-nav-account-menu-button'),
      $menu: find<HTMLDivElement>('.tn-utility-nav-account-menu'),
      $menuContainer: find<HTMLDivElement>('.tn-utility-nav-account-menu__container'),
    };
  },
} as IAccountNavigationElements;
